import React from 'react';
import { AutoComplete, Input, Button, Tooltip } from 'antd';
import { Search, FileSpreadsheet, FileText } from 'lucide-react';
import { Toolbar } from '../../common';
import { useAuditorSearch } from './auditorsTable.controller';

function AuditorsTableActions({ auditors, setRows, exporting, onExport }) {
    const { suggestions, searchValue, setSearchValue, onSearch } = useAuditorSearch(auditors, setRows);

    return (
        <Toolbar
            left={
                <AutoComplete
                    value={searchValue}
                    options={suggestions.map((suggestion) => ({ value: suggestion }))}
                    onSearch={onSearch}
                    onSelect={onSearch}
                    onChange={(value) => setSearchValue(value)}
                    placeholder="Buscar auditor..."
                    className="w-full sm:w-72">
                    <Input prefix={<Search className="text-surface-400" />} allowClear />
                </AutoComplete>
            }
            right={
                // Exports: every listed auditor with the complete list of PDVs assigned to them
                onExport && (
                    <>
                        <Tooltip title="Excel con los auditores y todos los PDVs que tienen asignados">
                            <Button
                                icon={<FileSpreadsheet />}
                                loading={exporting === 'excel'}
                                disabled={!!exporting && exporting !== 'excel'}
                                onClick={() => onExport('excel')}>
                                Exportar Excel
                            </Button>
                        </Tooltip>
                        <Tooltip title="PDF con los auditores y todos los PDVs que tienen asignados">
                            <Button
                                icon={<FileText />}
                                loading={exporting === 'pdf'}
                                disabled={!!exporting && exporting !== 'pdf'}
                                onClick={() => onExport('pdf')}>
                                Exportar PDF
                            </Button>
                        </Tooltip>
                    </>
                )
            }
        />
    );
}

export default AuditorsTableActions;
